import React from 'react'
import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { VegaIcon } from '../../../vega/icon/Icon'
import { VegaButtonTypes, VegaButton } from '../../../vega/button/Button'
import style from './bankItemBody.module.scss'
import Skeleton from 'react-loading-skeleton'
import { VegaTypo } from '../../../vega/typography/Typography'
import { PropTypes } from 'prop-types'
import { PaymentStatus } from '../../../../resources/constants/PaymentStatus'
import { BankLocation } from '../../../../utils/formatting/BankLocation'

/** Content of a bank item of the Update Box */
const BankItemBody = ({
	item: { bank: { name, location }, lastStatus, transactionFees } = {
		bank: { name: null, location: null }
	},
	hasHistory = false,
	isExpanded = false,
	onClick = () => {}
}) => {
	const { t, i18n } = useTranslation()
	const prefixTranslation = 'historyStatus'

	const status = lastStatus && PaymentStatus[lastStatus]
	return (
		<>
			<div className={cx(style.content)}>
				<p>
					<VegaTypo
						className={cx(style.subtitle)}
						label={status && t(prefixTranslation + status.statusTranslation + 'Subtitle')}
						width={200}
					/>
				</p>
				{transactionFees?.amount > 0 && (
					<div className={style.fees}>
						{new Intl.NumberFormat(i18n.language, {
							style: 'currency',
							currency: transactionFees?.currency,
							currencyDisplay: 'narrowSymbol'
						}).format(transactionFees?.amount)}
					</div>
				)}
			</div>
			<div className={cx(style.detail)}>
				<div className={cx(style.coordinate)}>
					{status ? (
						<>
							<div className={cx(style.row)}>
								<VegaIcon name="bank" size={12} />
								<div className={cx(style.label, style.bankName)}>
									{name || t('unknownBankName')}
								</div>
							</div>
							<div className={cx(style.row)}>
								<VegaIcon name="location" size={12} />
								<div className={cx(style.label)}>
									<BankLocation
										bankCity={location?.city}
										bankCountryISO={location?.country}
									/>
								</div>
							</div>
						</>
					) : (
						<Skeleton width={100} />
					)}
				</div>
				{hasHistory && (
					<VegaButton
						className={style.expand}
						type={VegaButtonTypes.LINK}
						label={isExpanded ? t('historyHideDetails') : t('historyShowDetails')}
						icon={isExpanded ? 'reduce' : 'open'}
						onClick={onClick}
					/>
				)}
			</div>
		</>
	)
}

BankItemBody.propTypes = {
	item: PropTypes.shape({
		bank: PropTypes.shape({
			name: PropTypes.string,
			location: PropTypes.shape({
				city: PropTypes.string,
				country: PropTypes.string
			})
		}),
		/** Current status, to select the text */
		lastStatus: PropTypes.oneOf(Object.keys(PaymentStatus))
	}),
	hasHistory: PropTypes.bool,
	isExpanded: PropTypes.bool,
	onClick: PropTypes.func
}

export { BankItemBody }
